import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { getSubsetAndItemParams } from '../../../../utils/getSubsetAndItemParams';
import { GlobalLocationStateType } from '../../../../types/types';

// Syncs active slave subsetId to context.
// URL is source of truth when pathname carries /item/ or /subset/ segment
// (row-expansion list mode OR detail+subset mode). Prevents stale slave
// fetches when master row changes from an open slave tab.
// Pure detail page (/detail/:itemId, no /subset/): falls back to slaveTabIndex.
export const useSyncSubsetIdToTab = (
  slaveTabIndex: number,
  masterDataset: any,
  setSubsetId: (value: string | null) => void
): void => {
  //TODO: Can this be refactored without parsing pathname?
  const { pathname } = useLocation<GlobalLocationStateType>();

  useEffect(() => {
    const { itemId, subsetId: subsetIdParam } =
      getSubsetAndItemParams(pathname);

    // URL wins when /item/ or /subset/ segment is present
    if (itemId !== undefined || subsetIdParam !== undefined) {
      setSubsetId(subsetIdParam ?? null);
      return;
    }

    // Detail page without subset segment: fall back to slaveTabIndex
    if (slaveTabIndex === 0) {
      setSubsetId(null);
      return;
    }
    const activeSubset = masterDataset?.subsets?.[slaveTabIndex - 1];
    setSubsetId(activeSubset?.datasetId ?? null);
  }, [slaveTabIndex, pathname, masterDataset, setSubsetId]);
};
